import { EpisodeAsset, SeriesAsset } from '../../../../queries/ats/titles/types/asset';
import { SvodSource, VodSource } from '../../../../queries/ats/titles/types/sources';
import { routes } from '../../../../routes/route-utils';
import { createContexts } from '../../../../views/ats-details/use-available-contexts';
import { getPreferredSource } from '../../../../views/ats-details/utils';

export function getNextEpisode(series: SeriesAsset, seasonNumber: number, episodeNumber: number) {
  const nextEpisodeInSeason = series.episodes.find((ep) => {
    return ep.season.sequenceNumber === seasonNumber && ep.episode.sequenceNumber > episodeNumber;
  });

  const nextEpisodeOutOfSeason = series.episodes.find((ep) => {
    return ep.season.sequenceNumber > seasonNumber && ep.episode.sequenceNumber > episodeNumber;
  });

  return nextEpisodeInSeason ?? nextEpisodeOutOfSeason;
}

export function getPrefferedSvodSource(episode: EpisodeAsset) {
  const contexts = createContexts(episode);
  const svodContext = contexts.find((x) => x.type === 'svod');

  if (svodContext === undefined) {
    return undefined;
  }

  const source = getPreferredSource(episode.sources, svodContext, {
    platformTitleId: undefined,
    orderByProviderId: undefined,
    orderByServiceType: 'svod',
  });

  if (source.type !== 'svod') {
    return undefined;
  }
  return source;
}

export function getPreferredVodSource(episode: EpisodeAsset) {
  const contexts = createContexts(episode);

  const vodContext = contexts.find((x) => x.type === 'vod');

  if (vodContext === undefined) {
    return undefined;
  }

  const source = getPreferredSource(episode.sources, vodContext, {
    platformTitleId: undefined,
    orderByProviderId: undefined,
    orderByServiceType: 'vod',
  });

  if (source.type !== 'vod') {
    return undefined;
  }

  return source;
}

export function getSourcePath(source: VodSource | SvodSource, episode: EpisodeAsset) {
  const route = routes.play({
    platformTitleId: source.platformTitleId,
    providerIdentifier: source.providerIdentifier,
    position: 0,
    masterId: episode.masterId,
  });
  return {
    pathname: route.pathname,
    search: route.search,
  };
}
